export default function BeforeAfterSection() {
  return (
    <section className="section-padding bg-background-100">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary-800 mb-4">
            A Different Way of Living
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-base leading-relaxed">
            While I don&apos;t promise a cure, I do facilitate a profound shift in quality of life. Below is a composite look at the sustainable transformation my clients experience when they move from fighting to partnering with their bodies.
          </p>
        </div>

        {/* Comparison Cards */}
        <div className="grid md:grid-cols-2 gap-8 relative max-w-4xl mx-auto">
          {/* Arrow indicator for desktop */}
          <div className="hidden md:flex absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
            <div className="w-12 h-12 rounded-full bg-accent-500 flex items-center justify-center shadow-card">
              <i className="ri-arrow-right-line text-white text-lg" />
            </div>
          </div>

          {/* Before */}
          <div className="bg-background-50 rounded-xl p-8">
            <h3 className="font-heading text-xl font-semibold text-primary-800 mb-6">
              Before Working Together
            </h3>
            <div className="space-y-5">
              <div>
                <h4 className="font-semibold text-primary-700 text-sm mb-1">Widespread pain</h4>
                <p className="text-foreground-600 text-sm">Daily pain with no management strategy or sense of control.</p>
              </div>
              <div>
                <h4 className="font-semibold text-primary-700 text-sm mb-1">Insomnia</h4>
                <p className="text-foreground-600 text-sm">Nights of broken, unrestorative sleep deepening the cycle of depletion.</p>
              </div>
              <div>
                <h4 className="font-semibold text-primary-700 text-sm mb-1">Brain fog</h4>
                <p className="text-foreground-600 text-sm">Difficulty concentrating, communicating, and completing basic tasks.</p>
              </div>
              <div>
                <h4 className="font-semibold text-primary-700 text-sm mb-1">Emotional exhaustion</h4>
                <p className="text-foreground-600 text-sm">Feeling overwhelmed, hopeless, and disconnected from any sense of joy.</p>
              </div>
            </div>
          </div>

          {/* After */}
          <div className="bg-[#6B8FA3] rounded-xl p-8">
            <h3 className="font-heading text-xl font-semibold text-background-50 mb-6">
              After the Energy Safe Method
            </h3>
            <div className="space-y-5">
              <div>
                <h4 className="font-semibold text-background-50 text-sm mb-1">Clear boundaries</h4>
                <p className="text-background-100/80 text-sm">Confidently protecting energy without guilt or over-explanation.</p>
              </div>
              <div>
                <h4 className="font-semibold text-background-50 text-sm mb-1">Sustainable energy</h4>
                <p className="text-background-100/80 text-sm">Pacing strategies that prevent crashes and preserve capacity for what matters.</p>
              </div>
              <div>
                <h4 className="font-semibold text-background-50 text-sm mb-1">Joyful movement</h4>
                <p className="text-background-100/80 text-sm">Re-engaging with gentle, energy-appropriate movement that feels good.</p>
              </div>
              <div>
                <h4 className="font-semibold text-background-50 text-sm mb-1">Emotional steadiness</h4>
                <p className="text-background-100/80 text-sm">A regulated nervous system and renewed sense of hope and possibility.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}